import {
    Component,
    OnInit,
    ViewChild,
    ViewChildren,
    QueryList,
} from '@angular/core';
import { ProposalService } from '../../services/proposal.service';
import {
    FormGroup,
    FormBuilder,
    Validators,
    FormControl,
} from '@angular/forms';
import { FormService } from 'src/app/services/form';
import { Proposal } from 'src/app/models/proposal';
import { DataService } from 'src/app/services/data.service';
import { PartInfo } from 'src/app/models/partinfo';
import { PartInfoInProposal } from 'src/app/models/partinfoinproposal';
import { ProposalPackageLevel } from 'src/app/models/proposalpackagelevel';
import { MatTabChangeEvent } from '@angular/material';
import { ProposalbasicinfoComponent } from './proposalbasicinfo/proposalbasicinfo.component';
import { ProposalsummaryComponent } from './proposalsummary/proposalsummary.component';
import { PackagelevelComponent } from './packagelevel/packagelevel.component';
import { ProposaloverrideComponent } from './proposaloverride/proposaloverride.component';
import { PartBasicInfo } from 'src/app/models/partbasicinfo';
import Helper from 'src/app/core/utility/helper';
import { ValidateEffectivityFrom } from 'src/app/commonUI/customValidators/proposaliinfofields.valdiator';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { Constants } from 'src/app/core/constants';
import { routerNgProbeToken } from '@angular/router/src/router_module';
import { CreateProposalDTO } from 'src/app/models/createproposaldto';
// import * as _ from 'lodash';
import cloneDeep from 'lodash/cloneDeep';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { ProposalEffectivity } from 'src/app/models/proposaleffectivity';
import { ProposalimagesComponent } from './proposalimages/proposalimages.component';
import { ProposalImage } from 'src/app/models/proposal-image';
import { FileToBeUploaded } from 'src/app/models/internal/file-tobe-uploaded';
import { ImageToBeDeleted } from 'src/app/models/internal/image-tobe-deleted';
import { PackageMaterial } from 'src/app/models/packagematerial';
import { Observable } from 'rxjs';
import { DocumentToBeDeleted } from 'src/app/models/internal/document-tobe-deleted';
import { ProposalDocument } from 'src/app/models/proposal-document';
import { FormFileToBeUploaded } from 'src/app/models/internal/formfile-tobe-uploaded';
import { UnitOfMeasurement } from 'src/app/models/internal/unit-of-measurement';
import Calculator from 'src/app/core/utility/calculator';
import { BasePage } from 'src/app/core/basepages/allbasepages';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { QueryGetMaterialDTO } from 'src/app/models/internal/query-getmaterial-dto';
import { AppGlobalDataService } from 'src/app/services/appglobaldata.service';
import { ComponentCanDeactivate } from 'src/app/core/interfaces/component-can-deactive.interface';
import { ProposalPackageLevelDunnageType } from 'src/app/models/ProposalPackageLevelDunnageType';
import { IInnerPackChanged } from 'src/app/core/interfaces/innerpack-change-event.interface';
import { PhysicalinspectionComponent } from './physicalinspection/physicalinspection.component';
import { NGXLogger } from 'ngx-logger';
import { AppSettings } from 'src/app/app.settings';
import { IShippableChanged } from 'src/app/core/interfaces/isshippable-change-event.interface';
import { DocumentToBeUploaded } from '../../models/internal/document-tobe-uploaded';
import { ProposalLogisticsComponent } from './proposallogistics/proposallogistics.component';
import { ProposalLocation } from '../../models/internal/proposal-location';
import { PackageLevelTemplate } from 'src/app/models/packageleveltemplate';


import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { MatDialog } from '@angular/material/dialog';
import { ProposalGapConfirmComponent } from './proposal-gap-confirm/proposal-gap-confirm.component';


@Component({
    selector: 'app-proposal',
    templateUrl: './proposal.component.html',
    styleUrls: ['./proposal.component.scss'],
})
export class ProposalComponent
    extends BasePage
    implements OnInit, ComponentCanDeactivate
{
    selectedTemplates: PackageLevelTemplate[] = [null, null, null];
    public createProposalDTO: CreateProposalDTO = new CreateProposalDTO();
    globalUOM: UnitOfMeasurement = new UnitOfMeasurement();
    proposalForm: FormGroup;
    proposalBasicInfoForm: FormGroup;
    partInfoInProposalForm: FormGroup;
    packageInfoForm: FormGroup;
    manufacturingLocationForm: FormGroup;
    secondaryProcessingLocationForm: FormGroup;
    proposalPrimaryPackageLevelForm: FormGroup;
    proposalSecondaryPackageLevelForm: FormGroup;
    proposalTertiaryPackageLevelForm: FormGroup;
    proposalOverrideForm: FormGroup;
    proposalImagesForm: FormGroup;
    proposalSummaryForm: FormGroup;
    externalComments: FormGroup;
    physicalinspection: FormGroup;
    proposalLogisticsInfoForm: FormGroup;
    public partsInCreateUpdateProposal: PartInfoInProposal =
        new PartInfoInProposal();
    public partNumbersInCreateUpdate: string[];
    selectedTabIndex: number = 0;
    highestTabIndex: number = 0;
    proposalBasicInfoForm_Invalid: boolean = false;
    partInfoInProposalForm_Invalid: boolean = false;
    packageInfoForm_Invalid: boolean = false;
    proposalManufacturingLocationForm_Invalid: boolean = false;
    proposalSecondaryProcessingLocationForm_Invalid: boolean = false;
    proposalPrimaryPackageLevelForm_Invalid: boolean = false;
    proposalTertiaryPackageLevelForm_Invalid: boolean = false;
    proposalSecondaryPackageLevelForm_Invalid: boolean = false;
    proposalImagesForm_Invalid: boolean = false;
    proposalOverrideForm_Invalid: boolean = false;
    proposalLogisticsInfoForm_Invalid: boolean = false;
    proposalBasicInfoForm_Valid: boolean = false;
    partInfoInProposalForm_Valid: boolean = false;
    packageInfoForm_Valid: boolean = false;
    proposalManufacturingLocationForm_Valid: boolean = false;
    proposalSecondaryProcessingLocationForm_Valid: boolean = false;
    proposalPrimaryPackageLevelForm_Valid: boolean = false;
    proposalSecondaryPackageLevelForm_Valid: boolean = false;
    proposalTertiaryPackageLevelForm_Valid: boolean = false;
    proposalImagesForm_Valid: boolean = false;
    proposalOverrideForm_Valid: boolean = false;
    proposalLogisticsInfoForm_Valid: boolean = false;
    @ViewChild(ProposalbasicinfoComponent)
    proposalbasicinfoComponent: ProposalbasicinfoComponent;
    @ViewChild(ProposalimagesComponent)
    proposalimagesComponent: ProposalimagesComponent;
    @ViewChild(PhysicalinspectionComponent)
    physicalinspectionComponent: PhysicalinspectionComponent;
    @ViewChild(ProposalLogisticsComponent)
    proposalLogisticsComponent: ProposalLogisticsComponent;
    @ViewChild(ProposalsummaryComponent)
    proposalsummaryComponent: ProposalsummaryComponent;
    @ViewChildren(PackagelevelComponent)
    packagelevelComponents: QueryList<PackagelevelComponent>;
    @ViewChild(ProposaloverrideComponent)
    proposaloverrideComponent: ProposaloverrideComponent;
    overridenImages: ProposalImage[] = [];
    proposalForMultipleParts: boolean = false;
    workflowStatusToSet: number;
    proposalId: string;
    proposalEstimateId: string = null;

    proposalEstimateEnabled: boolean = false;
    isUpdateMode = false;
    packageMaterialList: PackageMaterial[];
    pacakeTypeId: number;
    transportModeId: number;
    OkTOUploadImages = false;
    SubmitClicked = false;
    PhysicalInspectionMode: boolean = false;
    // SaveComplete = false;
    // TotalSaved = 0;
    TotalWeights: number[] = [3];
    TotalContainersInLevels: number[] = [3];
    TotalPartsInLevels: number[] = [3];
    TotalPackageHeight: number[] = [3];
    originalWorkFlowStatusId: number;
    formError = {
        Height: '',
        Width: '',
        Length: '',
    };
    effectiveDatesChanged: boolean;
    canProceedWithUpdate: boolean;

    constructor(
        private dataService: DataService,
        private proposalService: ProposalService,
        private fb: FormBuilder,
        public FormService: FormService,
        private toastService: ToastService,
        private readonly route: ActivatedRoute,
        logger: NGXLogger,
        appSettings: AppSettings,
        localstorageService: LocalstorageService,
        private readonly router: Router,
        private matDialog: MatDialog
    ) {
        super(localstorageService, logger, appSettings);
    }

    ngOnInit() {
        this.proposalService.globalUOMOnLoad.subscribe((uom) => {
            if (uom) {
                this.globalUOM = uom;
            }
        });

        this.proposalService.globalUOMOnUserToggle.subscribe((uom) => {
            if (uom) {
                this.globalUOM = uom;
            }
        });

        // initialize to clear global data cache from previous edit
        this.proposalService.RefreshCreateProposalDTO(this.createProposalDTO);
        this.proposalService.RefreshProposalSummaryFields();
        // get proposal id for update
        this.route.paramMap.subscribe((params) => {
            this.proposalId = params.get('id');
            if (this.proposalId) {
                this.isUpdateMode = true;
                this.OkTOUploadImages = true;
                this.getProposal(this.proposalId);
            }
        });
        this.route.queryParams.subscribe((params) => {
            const forTeslaCheck = (params['ForTesla'] || 0) != 0;
            if (forTeslaCheck) {
                this.createProposalDTO.DefaultProposal.PackageInfo.IsForTesla =
                    true;
                this.createProposalDTO.OverriddenProposal.PackageInfo.IsForTesla =
                    true;
            }
        });
        this.route.queryParams.subscribe((params) => {
            this.PhysicalInspectionMode = params['md'] === 'pi';
        });

        this.proposalService.proposalTabsSelectedIndex.subscribe((index) => {
            this.selectedTabIndex = index;
            if (this.proposalForm) {
                this.refreshProposalSummary();
            }
        });

        if (!this.isUpdateMode) {
            this.proposalService.partInfoToBeCreatedList.subscribe((parts) => {
                if (
                    parts.filter((x) => x.IsSelected).length == 1 &&
                    this.proposalEstimateId == null
                ) {
                    let estimateId = parts.find(
                        (x) => x.IsSelected
                    ).ProposalEstimateId;
                    this.proposalEstimateId = estimateId
                        ? estimateId
                        : this.proposalEstimateId;
                    this.proposalEstimateEnabled =
                        this.proposalEstimateId != undefined;
                }
                this.populatePartsInProposalDTO(parts);
                this.createProposalDTO.DefaultProposal.PartInfo.Parts = parts;
                this.logDebug('porp to be created for parts', parts);
            });
            this.proposalService.RefreshPartInfoList(
                this.partsInCreateUpdateProposal.Parts
            );
        }

        this.proposalForm = this.fb.group({});
        this.proposalForMultipleParts =
            this.partsInCreateUpdateProposal &&
            this.partsInCreateUpdateProposal.Parts &&
            this.partsInCreateUpdateProposal.Parts.length > 1;
        this.highestTabIndex = this.proposalForMultipleParts ? 9 : 8;
        this.proposalService.RefreshHighestTabIndex(this.highestTabIndex);

        this.getDunnageTypes();
        this.getPackageTypes();
        this.getReasonsNonSubTestDoc();
        this.getTrasportModes();
        this.getSourceTypes();
        this.getSourceTypeIdsforInnerPack();
        this.proposalService.packageTypeId.subscribe((pacakeTypeId) => {
            this.logDebug('package type changed', pacakeTypeId);
            if (pacakeTypeId) {
                this.pacakeTypeId = pacakeTypeId;
                this.getMaterials(this.pacakeTypeId, this.transportModeId);
            }
        });
        this.proposalService.transportModeId.subscribe((transportModeId) => {
            this.logDebug('transportModeId changed', transportModeId);
            if (transportModeId) {
                this.transportModeId = transportModeId;
                this.getMaterials(this.pacakeTypeId, this.transportModeId);
            }
        });
    }
    ngOnDestroy() {
        this.proposalService.RefreshProposalTabsSelectedIndex(0);
    }

    canDeactivate(): boolean {
        return !this.proposalForm.dirty || this.SubmitClicked;
    }

    populatePartsInProposalDTO(parts: PartBasicInfo[]) {
        if (!this.partsInCreateUpdateProposal.Parts) {
            this.partsInCreateUpdateProposal.Parts = [];
        }
        parts.forEach((p) => {
            const newP = cloneDeep(p);
            newP.IsSelected = false;
            this.partsInCreateUpdateProposal.Parts.push(newP);
        });
    }

    promoteArrElement(foo, arr) {
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].Description === foo) {
                const a = arr.splice(i, 1); // removes the item
                arr.unshift(a[0]); // adds it back to the beginning
            }
        }
    }

    getDunnageTypes() {
        this.dataService.getDunnageTypes().subscribe((response: any) => {
            // re-arrange so 'None' is on the top
            if (response && response.Data) {
                const first = 'None';
                this.promoteArrElement('None', response.Data);
                // response.Data.sort(function(x, y) { return x === first ? -1 : y === first ? 1 : 0; });
            }
            this.proposalService.RefreshdunnageTypeMasterList(response.Data);
        });
    }
    getPackageTypes() {
        this.dataService.getPackageTypes().subscribe((response: any) => {
            this.proposalService.RefreshpackageTypeMasterList(response.Data);
        });
    }
    getReasonsNonSubTestDoc() {
        this.dataService
            .getReasonsNonSubTestDoc()
            .subscribe((response: any) => {
                this.proposalService.RefreshreasonsNonSubTestDocMasterList(
                    response.Data
                );
            });
    }
    getTrasportModes() {
        this.dataService.getTransportModes().subscribe((response: any) => {
            this.proposalService.RefreshtransportModeMasterList(response.Data);
        });
    }
    getSourceTypes() {
        this.dataService.getParentSourceTypes().subscribe((response: any) => {
            this.proposalService.RefreshsourceTypeMasterList(response.Data);
        });
    }

    //TMS-20237 Move call to get innerpack st ids to proposal component to avoid multiple calls
    getSourceTypeIdsforInnerPack() {
        this.dataService
            .getInnerPackServiceSourceTypes()
            .subscribe((response: []) => {
                this.proposalService.RefreshInnerPacksourceTypeMasterList(
                    response
                );
            });
    }
    getMaterials(packageTypeId: number, transportModeId: number) {
        this.logDebug(
            'getMaterials in proposal comp',
            packageTypeId,
            transportModeId
        );
        if (packageTypeId && transportModeId) {
            const queryGetMaterialDTO: QueryGetMaterialDTO =
                new QueryGetMaterialDTO();
            queryGetMaterialDTO.PackageTypeId = packageTypeId;
            queryGetMaterialDTO.TransportModeId = transportModeId;
            this.logDebug('in getMaterials', queryGetMaterialDTO);
            this.dataService
                .getMaterials(queryGetMaterialDTO)
                .subscribe((response: any) => {
                    if (response && response.Data != null) {
                        this.packageMaterialList = response.Data;
                        this.proposalService.RefreshpackageMaterialMasterList(
                            this.packageMaterialList
                        );
                    }
                });
        }
        // // get material list again if for diff packagetypeid and if not already fetched
        // if(this.pacakeTypeId == packageTypeId && this.packageMaterialList)
        // {
        //     this.proposalService.RefreshpackageMaterialMasterList(this.packageMaterialList);
        // }
        // else
        // {
        //     this.dataService.getMaterials(packageTypeId).subscribe((response: any) => {
        //         if (response && response.Data != null) {
        //             this.packageMaterialList =  response.Data;
        //             this.proposalService.RefreshpackageMaterialMasterList(this.packageMaterialList);
        //         }
        //     });
        //     }
    }

    getProposal(proposalId: string) {
        this.dataService.getProposal(proposalId).subscribe((response: any) => {
            // this.CheckForUnauthorized(response);
            // check for unauthorized code returned
            if (response.HttpStatusCode == 'Unauthorized') {
                this.router.navigate(['/auth/unauthorized']);
            }
            if (response && response.Data != null) {
                this.createProposalDTO = new CreateProposalDTO();
                this.createProposalDTO.DefaultProposal = cloneDeep(
                    response.Data
                );
              this.createProposalDTO.DefaultProposal.ManufacturingLocation = Object.assign(new ProposalLocation(), this.createProposalDTO.DefaultProposal.ManufacturingLocation);
              this.createProposalDTO.DefaultProposal.SecondaryProcessingLocation = Object.assign(new ProposalLocation(), this.createProposalDTO.DefaultProposal.SecondaryProcessingLocation);
              this.logDebug('ManufacturingLocation:', this.createProposalDTO.DefaultProposal.ManufacturingLocation.isManual());
              this.logDebug('SecondaryProcessingLocation:', this.createProposalDTO.DefaultProposal.SecondaryProcessingLocation);
                this.originalWorkFlowStatusId =
                    this.createProposalDTO.DefaultProposal.PackageInfo.WorkflowStatusId;
                this.partNumbersInCreateUpdate = [
                    this.createProposalDTO.DefaultProposal.PartInfo.Parts[0]
                        .PartNumber,
                ];
                this.generateOriginaltemplateHeight();
                this.createProposalDTO.DefaultProposal.ProposalId =
                    +this.proposalId;
                this.logDebug(
                    'proposal fetched for update',
                    this.createProposalDTO
                );
                this.proposalService.RefreshCreateProposalDTO(
                    this.createProposalDTO
                );
                if (
                    this.createProposalDTO.DefaultProposal.PartInfo.Parts[0]
                        .ProposalEstimateId > 0
                )
                    this.proposalEstimateId =
                        this.createProposalDTO.DefaultProposal.PartInfo.Parts[0]
                            .ProposalEstimateId + '';
                this.populatePartsInProposalDTO(
                    this.createProposalDTO.DefaultProposal.PartInfo.Parts
                );
            }
        });
    }

    generateOriginaltemplateHeight() {
        // consider inner pack flag for previous level before calculating height
        if (
            this.createProposalDTO.DefaultProposal.PackageInfo
                .ProposalPackageLevels[2]
        ) {
            if (
                !this.createProposalDTO.DefaultProposal.PackageInfo
                    .ProposalPackageLevels[1].IsInnerPack
            ) {
                this.createProposalDTO.DefaultProposal.PackageInfo.ProposalPackageLevels[2].Height -=
                    this.createProposalDTO.DefaultProposal.PackageInfo
                        .ProposalPackageLevels[1].Height *
                    this.createProposalDTO.DefaultProposal.PackageInfo
                        .ProposalPackageLevels[2].NoOfLayers;
            }
        }
        if (
            this.createProposalDTO.DefaultProposal.PackageInfo
                .ProposalPackageLevels[1]
        ) {
            if (
                !this.createProposalDTO.DefaultProposal.PackageInfo
                    .ProposalPackageLevels[0].IsInnerPack
            ) {
                this.createProposalDTO.DefaultProposal.PackageInfo.ProposalPackageLevels[1].Height -=
                    this.createProposalDTO.DefaultProposal.PackageInfo
                        .ProposalPackageLevels[0].Height *
                    this.createProposalDTO.DefaultProposal.PackageInfo
                        .ProposalPackageLevels[1].NoOfLayers;
            }
        }
    }

    refreshProposalSummary() {
        this.updateDefaultProposal(false);
        this.setOkToImageUploadFlag();
        if (!this.isUpdateMode) {
        }
    }

    updateDefaultProposal(updateUoM: boolean) {
        this.RefreshFormGroups();
        if (updateUoM) {
            // if(this.globalUOM.Id != Constants.IMPERIAL_UOM_ID)
            // {
            // Value in db should always be in Imperial uom so reset all forms to Imperial before reading values for submit
            // this.globalUOM = Helper.getUoMObject(Constants.IMPERIAL_UOM_ID);
            this.updateMeasurements();
            // }
        }
        this.createProposalDTO.DefaultProposal = cloneDeep(
            this.getDefaultProposal(false)
        );
        // update override only if in create mode
        if (!this.isUpdateMode) {
            const overriddenParts =
                this.partsInCreateUpdateProposal.Parts.filter(
                    (a) => a.IsSelected == true
                );
            if (
                overriddenParts &&
                overriddenParts.length > 0 &&
                this.isAtLeastOneFieldOverriden()
            ) {
                this.createProposalDTO.OverriddenProposal = cloneDeep(
                    this.getDefaultProposal(true)
                );
                this.overrideProposalValues();
                this.createProposalDTO.OverriddenProposal.ImageInfo =
                    this.overridenImages;
            }
        } else {
            this.createProposalDTO.OverriddenProposal = null;
        }
    }

    updateMeasurements() {
        if (this.globalUOM.Id != Constants.IMPERIAL_UOM_ID) {
            this.proposalService.RefreshglobalUOMOnSubmit(
                Helper.getUoMObject(Constants.IMPERIAL_UOM_ID)
            );
            // this.proposalbasicinfoComponent.updateMeasurements();
            // this.packagelevelComponents.forEach(packagelevelComponent => {
            //     packagelevelComponent.globalUOM = this.globalUOM;
            //     packagelevelComponent.updateMeasurementsOnLoad();
            // });
        }
    }

    getDefaultProposal(isOverride: boolean): Proposal {
        let prop: Proposal;
        if (!this.isUpdateMode) {
            prop = new Proposal();
        } else {
            prop = cloneDeep(this.createProposalDTO.DefaultProposal);
        }
        if (this.isUpdateMode) {
            prop.ProposalId = +this.proposalId;
        }

        prop.ImageInfo = this.createProposalDTO.DefaultProposal.ImageInfo;
        prop.DocumentInfo = this.createProposalDTO.DefaultProposal.DocumentInfo;
        this.route.queryParams.subscribe((params) => {
            const forTeslaCheck = (params['ForTesla'] || 0) != 0;
            if (forTeslaCheck) {
                prop.PackageInfo.IsForTesla = true;
            }
        });
        // clonedeep overwrites object structure
        prop.PackageInfo = Object.assign(
            prop.PackageInfo,
            this.packageInfoForm.value
        );

        prop.ManufacturingLocation = Object.assign(
          new ProposalLocation(),
          this.manufacturingLocationForm.value
        );

        prop.SecondaryProcessingLocation = Object.assign(
          new ProposalLocation(),
          this.secondaryProcessingLocationForm.value,
        );

      prop.PackageInfo.SourceTypeIds[0] = prop.PackageInfo.SourceTypeId;
        prop.PackageInfo.ProposalReasonTestDoc.ReasonsNonSubTestDocId =
            this.proposalImagesForm.get('ReasonsNonSubTestDocId').value;
        prop.PackageInfo.NonSubTestDocReason = this.proposalImagesForm.get(
            'NonSubTestDocReason'
        ).value;
        prop.PackageInfo.TestDocComment =
            this.proposalImagesForm.get('TestDocComment').value;

        let tempprim: ProposalPackageLevelDunnageType[] = [];
        let tempsec: ProposalPackageLevelDunnageType[] = [];
        let temptertiary: ProposalPackageLevelDunnageType[] = [];
        if (this.isUpdateMode) {
            tempprim = this.getProposalPackageLevelDunnageTypesUpdate(
                this.proposalPrimaryPackageLevelForm.get(
                    'proposalPackageLevelDunnageTypes'
                ).value,
                prop.PackageInfo.ProposalPackageLevels[0]
            );
            tempsec = this.getProposalPackageLevelDunnageTypesUpdate(
                this.proposalSecondaryPackageLevelForm.get(
                    'proposalPackageLevelDunnageTypes'
                ).value,
                prop.PackageInfo.ProposalPackageLevels[1]
            );
            temptertiary = this.getProposalPackageLevelDunnageTypesUpdate(
                this.proposalTertiaryPackageLevelForm.get(
                    'proposalPackageLevelDunnageTypes'
                ).value,
                prop.PackageInfo.ProposalPackageLevels[2]
            );
        }
        if (!this.isUpdateMode) {
            tempprim = this.getProposalPackageLevelDunnageTypesNew(
                this.proposalPrimaryPackageLevelForm.get(
                    'proposalPackageLevelDunnageTypes'
                ).value
            );
            tempsec = this.getProposalPackageLevelDunnageTypesNew(
                this.proposalSecondaryPackageLevelForm.get(
                    'proposalPackageLevelDunnageTypes'
                ).value
            );
            temptertiary = this.getProposalPackageLevelDunnageTypesNew(
                this.proposalTertiaryPackageLevelForm.get(
                    'proposalPackageLevelDunnageTypes'
                ).value
            );
        }

        const primaryLevel = cloneDeep(
            this.proposalPrimaryPackageLevelForm.value
        );
        if (tempprim != null) {
            primaryLevel['proposalPackageLevelDunnageTypes'] = tempprim;
        }
        const secondaryLevel = cloneDeep(
            this.proposalSecondaryPackageLevelForm.value
        );
        if (tempsec != null) {
            secondaryLevel['proposalPackageLevelDunnageTypes'] = tempsec;
        }
        const tertiaryLevel = cloneDeep(
            this.proposalTertiaryPackageLevelForm.value
        );
        if (temptertiary != null) {
            tertiaryLevel['proposalPackageLevelDunnageTypes'] = temptertiary;
        }
        prop.PackageInfo.ProposalEffectivity.EffectiveFrom =
            this.packageInfoForm.controls['EffectiveFrom'].value;
        
        prop.PackageInfo.ProposalEffectivity.EffectiveTo = this.packageInfoForm.controls['EffectiveTo'].value;
        // prop.PackageInfo.ProposalEffectivity.EffectiveFrom =
        prop.PackageInfo.WorkflowStatusId = this.workflowStatusToSet;
        if (!this.isUpdateMode) {
            prop.PackageInfo.ProposalPackageLevels = [];
            prop.PackageInfo.ProposalPackageLevels.push(primaryLevel);
            if (secondaryLevel && secondaryLevel.PackageMaterialId) {
                prop.PackageInfo.ProposalPackageLevels.push(secondaryLevel);
            }
            if (tertiaryLevel && tertiaryLevel.PackageMaterialId) {
                prop.PackageInfo.ProposalPackageLevels.push(tertiaryLevel);
            }
            prop.PartInfo.Parts = [];
            const partsToAdd = cloneDeep(
                this.partsInCreateUpdateProposal.Parts
            );
            prop.PartInfo.Parts = partsToAdd.filter(
                (a) => a.IsSelected == isOverride
            );
        } else {
            prop.PackageInfo.ProposalPackageLevels[0] = Object.assign(
                prop.PackageInfo.ProposalPackageLevels[0],
                primaryLevel
            );
            if (
                prop.PackageInfo.ProposalPackageLevels.length > 1 &&
                prop.PackageInfo.ProposalPackageLevels[1]
            ) {
                prop.PackageInfo.ProposalPackageLevels[1] = Object.assign(
                    prop.PackageInfo.ProposalPackageLevels[1],
                    secondaryLevel
                );
            }
            if (
                prop.PackageInfo.ProposalPackageLevels.length > 2 &&
                prop.PackageInfo.ProposalPackageLevels[2]
            ) {
                prop.PackageInfo.ProposalPackageLevels[2] = Object.assign(
                    prop.PackageInfo.ProposalPackageLevels[2],
                    tertiaryLevel
                );
            }
        }
        this.logDebug(prop.PackageInfo.ProposalPackageLevels);

        prop.PartInfo.Length =
            this.partInfoInProposalForm.controls['Length'].value;
        prop.PartInfo.Width =
            this.partInfoInProposalForm.controls['Width'].value;
        prop.PartInfo.Height =
            this.partInfoInProposalForm.controls['Height'].value;
        prop.PartInfo.Weight =
            this.partInfoInProposalForm.controls['Weight'].value;
        prop.PartInfo.Material =
            this.partInfoInProposalForm.controls['Material'].value;

        prop.PackageInfo.UOMSystemId = this.globalUOM.Id;
        
        //only if the proposal is new, set this flag
        if (this.createProposalDTO.DefaultProposal.PackageInfo.IsTeslaCreated === undefined){
            prop.PackageInfo.IsTeslaCreated = !this.IsSupplier;
        }

        prop.ExternalComment =
            this.externalComments.controls['ExternalComment'].value;
        if (prop.ExternalComment != null) {
            prop.ExternalComment = prop.ExternalComment.trim();
        }

        if (this.proposalLogisticsInfoForm != undefined) {
            prop.WeightUtilization =
                this.proposalLogisticsInfoForm.controls[
                    'WeightUtilization'
                ].value;
            prop.CubeUtilization =
                this.proposalLogisticsInfoForm.controls[
                    'CubeUtilization'
                ].value;
            prop.ContainerTotalWeight =
                this.proposalLogisticsInfoForm.controls['TotalWeight'].value;
            prop.TotalPartQuantity =
                this.proposalLogisticsInfoForm.controls[
                    'TotalPartQuantity'
                ].value;
            prop.LowUtilizationComments =
                this.proposalLogisticsInfoForm.controls[
                    'LowUtilizationComments'
                ].value;

            prop.PackageInfo.IsRotatable =
                this.proposalLogisticsInfoForm.controls['IsRotatable'].value;
            prop.PackageInfo.RotationComment =
                this.proposalLogisticsInfoForm.controls[
                    'RotationComment'
                ].value;

            prop.PackageInfo.IsStackable =
                this.proposalLogisticsInfoForm.controls['IsStackable'].value;
            prop.PackageInfo.NonStackabilityReason =
                this.proposalLogisticsInfoForm.controls[
                    'NonStackabilityReason'
                ].value;

            prop.PackageInfo.NoOfStackableUnitsForShipping =
                this.proposalLogisticsInfoForm.controls[
                    'NoOfStackableUnitsForShipping'
                ].value;
            prop.PackageInfo.NoOfStackableUnitsForWarehousing =
                this.proposalLogisticsInfoForm.controls[
                    'NoOfStackableUnitsForWarehousing'
                ].value;
        }
        return prop;
    }

    getProposalPackageLevelDunnageTypesUpdate(
        proposalPackageLevelDunnageTypes,
        proposalpackagelevel
    ) {
        const tempppldtlist: ProposalPackageLevelDunnageType[] = [];
        if (proposalpackagelevel) {
            if (
                proposalpackagelevel.IsDunnageRequired &&
                proposalpackagelevel.proposalPackageLevelDunnageTypes
            ) {
                proposalpackagelevel.proposalPackageLevelDunnageTypes.forEach(
                    (x) => {
                        if (x.hasOwnProperty('Id') && x['Id'] > 0) {
                            x['Enabled'] = false;
                            tempppldtlist.push(x);
                        }
                    }
                );
            }
        }
        if (proposalPackageLevelDunnageTypes) {
            proposalPackageLevelDunnageTypes.forEach((element) => {
                const tempppldt: ProposalPackageLevelDunnageType =
                    new ProposalPackageLevelDunnageType();
                if (element['Id'] > 0) {
                    element['Enabled'] = false;
                    tempppldtlist.push(element);
                } else if (!isNaN(element)) {
                    tempppldt['DunnageTypeId'] = <number>element;
                    tempppldt['Id'] = 0;
                    tempppldt['Enabled'] = true;
                    if (
                        tempppldtlist.find(
                            (x) =>
                                x.Enabled &&
                                x.DunnageTypeId == tempppldt.DunnageTypeId
                        )
                            ? false
                            : true
                    ) {
                        tempppldtlist.push(tempppldt);
                    }
                }
            });
        }
        return tempppldtlist;
    }

    getProposalPackageLevelDunnageTypesNew(proposalPackageLevelDunnageTypes) {
        const tempppldtlist: ProposalPackageLevelDunnageType[] = [];
        if (proposalPackageLevelDunnageTypes) {
            proposalPackageLevelDunnageTypes.forEach((element) => {
                const tempppldt: ProposalPackageLevelDunnageType =
                    new ProposalPackageLevelDunnageType();
                if (element['DunnageTypeId'] != null) {
                    tempppldt['DunnageTypeId'] = <number>(
                        element['DunnageTypeId']
                    );
                } else {
                    tempppldt['DunnageTypeId'] = <number>element;
                }
                tempppldtlist.push(tempppldt);
            });
        }
        return tempppldtlist;
    }

    isAtLeastOneFieldOverriden() {
        let atLeastOneFieldOverridden: Boolean = false;
        if (!this.proposalOverrideForm) {
            return false;
        }
        const controls = this.proposalOverrideForm.controls;
        atLeastOneFieldOverridden = this.AnyFormFieldsHasValue(
            [
                'Length',
                'Width',
                'Height',
                'Weight',
                'PrimaryTareWeight',
                'SecondaryTareWeight',
                'QPC',
                'SecondaryContainersPerLayer',
                'SecondaryNoOfLayers',
                'PrimaryDunnageType',
                'PrimaryDunnage',
                'SecondaryDunnageType',
                'SecondaryDunnage',
                'TertiaryTareWeight',
                'TertiaryContainersPerLayer',
                'TertiaryNoOfLayers',
            ],
            this.proposalOverrideForm
        );
        return atLeastOneFieldOverridden;
    }

    RefreshTotals() {
        this.RefreshFormGroups();
        this.RefreshLevelsTotalWeight();
        this.RefreshLevelsTotals();
        this.RefreshPackageHeight();
        this.RefreshLogisticsInfo();
    }
    RefreshInnerPackFlags(innerPackChangeDetails: IInnerPackChanged) {
        if (this.packagelevelComponents) {
            this.packagelevelComponents.forEach((packagelevelComponent) => {
                packagelevelComponent.SetInnerPackFlags(
                    innerPackChangeDetails.level,
                    innerPackChangeDetails.IsInnerPackChecked
                );
            });
        }
    }

    RefreshShippableFlags(shippableChangeDetails: IShippableChanged) {
        if (this.packagelevelComponents) {
            this.packagelevelComponents.forEach((packagelevelComponent) => {
                packagelevelComponent.SetShippableFlags(
                    shippableChangeDetails.level,
                    shippableChangeDetails.IsShippablePackChecked
                );
            });
        }
    }
    LevelClearClicked(level: number) {
        if (level == 1) {
            return;
        }
        const previousLevel = level - 1;
        const innerPackChangeDetails = {} as IInnerPackChanged;
        innerPackChangeDetails.level = previousLevel;
        innerPackChangeDetails.IsInnerPackChecked = this.packagelevelComponents
            .find((a) => a.level == previousLevel)
            .ProposalPackageLevelForm.get('IsInnerPack').value;
        const shippableChangeDetails = {} as IShippableChanged;
        shippableChangeDetails.level = previousLevel;
        shippableChangeDetails.IsShippablePackChecked =
            this.packagelevelComponents
                .find((a) => a.level == previousLevel)
                .ProposalPackageLevelForm.get('IsShippable').value;
        this.proposalsummaryComponent.LevelClearClicked(level);
        this.RefreshInnerPackFlags(innerPackChangeDetails);
        this.RefreshShippableFlags(shippableChangeDetails);
    }
    RefreshPackageHeight() {
        // TMS-4595 : if previous level is 'inner pack' then don't count it's height in calculation
        if (!this.getLevelFormValue(1, 'IsInnerPack')) {
            this.TotalPackageHeight[1] =
                Calculator.GetTotalPackageHeightSecondary(
                    this.getLevelFormValue(1, 'Height'),
                    this.getLevelFormValue(2, 'NoOfLayers'),
                    this.getLevelFormValue(2, 'Height')
                );
        } else {
            this.TotalPackageHeight[1] = this.getLevelFormValue(2, 'Height');
        }
        if (!this.getLevelFormValue(2, 'IsInnerPack')) {
            this.TotalPackageHeight[2] =
                Calculator.GetTotalPackageHeightSecondary(
                    this.TotalPackageHeight[1],
                    this.getLevelFormValue(3, 'NoOfLayers'),
                    this.getLevelFormValue(3, 'Height')
                );
        } else {
            this.TotalPackageHeight[2] = this.getLevelFormValue(3, 'Height');
        }
        if (this.packagelevelComponents) {
            this.packagelevelComponents.forEach((packagelevelComponent) => {
                if (packagelevelComponent.levelName == 'Secondary') {
                    packagelevelComponent.setTotalPackageHeight(
                        this.TotalPackageHeight
                    );
                }
                if (packagelevelComponent.levelName == 'Tertiary') {
                    packagelevelComponent.setTotalPackageHeight(
                        this.TotalPackageHeight
                    );
                }
            });
        }
    }

    RefreshLogisticsInfo() {
        let totalWeight = this.TotalWeights[0];
        let totalHeight = this.getLevelFormValue(1, 'Height');
        let totalLength = this.getLevelFormValue(1, 'Length');
        let totalWidth = this.getLevelFormValue(1, 'Width');
        let totalPartQuanty = this.TotalPartsInLevels[0];
        if (this.TotalWeights[2] > 0) {
            totalWeight = this.TotalWeights[2];
            totalHeight = this.TotalPackageHeight[2];
            totalLength = this.getLevelFormValue(3, 'Length');
            totalWidth = this.getLevelFormValue(3, 'Width');
            totalPartQuanty = this.TotalPartsInLevels[2];
        } else if (this.TotalWeights[1] > 0) {
            totalWeight = this.TotalWeights[1];
            totalHeight = this.TotalPackageHeight[1];
            totalLength = this.getLevelFormValue(2, 'Length');
            totalWidth = this.getLevelFormValue(2, 'Width');
            totalPartQuanty = this.TotalPartsInLevels[1];
        }

        let nofStackableUnitsForShipping =
            this.proposalLogisticsInfoForm.controls[
                'NoOfStackableUnitsForShipping'
            ].value;
        let isStackable =
            this.proposalLogisticsInfoForm.controls['IsStackable'].value;
        let isRotatable =
            this.proposalLogisticsInfoForm.controls['IsRotatable'].value;
        this.proposalLogisticsComponent.setUtilization(
            totalLength,
            totalWidth,
            totalHeight,
            totalWeight,
            totalPartQuanty,
            isStackable,
            nofStackableUnitsForShipping,
            isRotatable
        );

        //Code below is for UNIT TEST ONLY !!!!!!!
        //if isRotatable, CubeUtilization should be 68.97%, WeightUtilization should be 26.05%, total part 560, total weight 11200
        //if not, CubeUtilization should be 64.04%, WeightUtilization should be 24.19%, total part 520, total weight 10400
        // this.proposalLogisticsComponent.setUtilization(
        //     48, // packageLength
        //     45, // packageWidth
        //     36, // packageHeight
        //     200, // packageWeight
        //     10, // packageTotalPartQuantity (example: 10 parts per package)
        //     true, // isStackable
        //     2, // nofStackableUnitsForShipping
        //     isRotatable // isRotatable
        // );
    }

    RefreshLevelsTotalWeight() {
        const partWeight = this.partInfoInProposalForm.get('Weight').value;
        this.TotalWeights[0] = Calculator.GetTotalWeight_Primary(
            this.getLevelFormValue(1, 'QPC'),
            partWeight,
            this.getLevelFormValue(1, 'TareWeight')
        );
        this.TotalWeights[1] = Calculator.GetTotalWeight_Secondary(
            this.TotalWeights[0],
            this.getLevelFormValue(2, 'ContainersPerLayer'),
            this.getLevelFormValue(2, 'NoOfLayers'),
            this.getLevelFormValue(2, 'TareWeight')
        );
        this.TotalWeights[2] = Calculator.GetTotalWeight_Tertiary(
            this.TotalWeights[1],
            this.getLevelFormValue(3, 'ContainersPerLayer'),
            this.getLevelFormValue(3, 'NoOfLayers'),
            this.getLevelFormValue(3, 'TareWeight')
        );
        if (this.packagelevelComponents) {
            this.packagelevelComponents.forEach((packagelevelComponent) => {
                packagelevelComponent.setTotalWeight(this.TotalWeights);
                if (
                    this.TotalWeights[packagelevelComponent.level] !=
                        undefined &&
                    this.TotalWeights[packagelevelComponent.level] != null
                ) {
                    packagelevelComponent.ValidateForm();
                }
                // if (packagelevelComponent.levelName === 'Primary') {
                //     packagelevelComponent.setpercentagePackageUtilization(this.partInfoInProposalForm, packagelevelComponent.ProposalPackageLevelForm);
                // }
                packagelevelComponent.setWeightPercentageUtilization(
                    partWeight,
                    this.TotalWeights
                );
            });
        }
    }

    RefreshLevelsTotals() {
        this.TotalContainersInLevels[0] =
            Calculator.GetTotalContainerQuantity_Primary();
        this.TotalContainersInLevels[1] =
            Calculator.GetTotalContainerQuantity_Secondary(
                this.getLevelFormValue(2, 'ContainersPerLayer'),
                this.getLevelFormValue(2, 'NoOfLayers')
            );
        this.TotalContainersInLevels[2] =
            Calculator.GetTotalContainerQuantity_Tertiary(
                this.TotalContainersInLevels[1],
                this.getLevelFormValue(3, 'ContainersPerLayer'),
                this.getLevelFormValue(3, 'NoOfLayers')
            );
        if (this.packagelevelComponents) {
            this.packagelevelComponents.forEach((packagelevelComponent) => {
                packagelevelComponent.setTotalContainersInLevel(
                    this.TotalContainersInLevels
                );
            });
        }

        this.TotalPartsInLevels[0] = Calculator.GetTotalPartQuantity_Primary(
            this.getLevelFormValue(1, 'QPC')
        );
        this.TotalPartsInLevels[1] = Calculator.GetTotalPartQuantity_Secondary(
            this.TotalPartsInLevels[0],
            this.getLevelFormValue(2, 'ContainersPerLayer'),
            this.getLevelFormValue(2, 'NoOfLayers')
        );
        this.TotalPartsInLevels[2] = Calculator.GetTotalPartQuantity_Tertiary(
            this.TotalPartsInLevels[1],
            this.getLevelFormValue(3, 'ContainersPerLayer'),
            this.getLevelFormValue(3, 'NoOfLayers')
        );
        if (this.packagelevelComponents) {
            this.packagelevelComponents.forEach((packagelevelComponent) => {
                packagelevelComponent.setTotalPartsInLevel(
                    this.TotalPartsInLevels
                );
                packagelevelComponent.setpercentagePackageUtilization(
                    this.partInfoInProposalForm,
                    packagelevelComponent.ProposalPackageLevelForm
                );
            });
        }
    }

    getLevelFormValue(level: number, controlName: string) {
        switch (level) {
            case 1: {
                return this.proposalPrimaryPackageLevelForm.get(controlName)
                    .value;
                break;
            }
            case 2: {
                return this.proposalSecondaryPackageLevelForm.get(controlName)
                    .value;
                break;
            }
            case 3: {
                if (this.proposalTertiaryPackageLevelForm) {
                    return this.proposalTertiaryPackageLevelForm.get(
                        controlName
                    ).value;
                } else {
                    return null;
                }
                break;
            }
        }
    }

    AnyFormFieldsHasValue(fieldNames: string[], g: FormGroup) {
        const values: any[] = [];
        fieldNames.forEach((field) => {
            values.push(g.controls[field].value);
        });
        return values.some(this.isValidValue);
    }

    isValidValue(value: any) {
        if (value !== null && value !== 0) {
            return true;
        }
    }

    overrideProposalValues() {
        const overridenProposal = this.createProposalDTO.OverriddenProposal;
        overridenProposal.PartInfo.Length = this.SetOverrideFieldValue(
            'Length',
            overridenProposal.PartInfo.Length
        );
        overridenProposal.PartInfo.Width = this.SetOverrideFieldValue(
            'Width',
            overridenProposal.PartInfo.Width
        );
        overridenProposal.PartInfo.Height = this.SetOverrideFieldValue(
            'Height',
            overridenProposal.PartInfo.Height
        );
        overridenProposal.PartInfo.Weight = this.SetOverrideFieldValue(
            'Weight',
            overridenProposal.PartInfo.Weight
        );
        overridenProposal.PackageInfo.ProposalPackageLevels[0].QPC =
            this.SetOverrideFieldValue(
                'QPC',
                overridenProposal.PackageInfo.ProposalPackageLevels[0].QPC
            );
        overridenProposal.PackageInfo.ProposalPackageLevels[0].TareWeight =
            this.SetOverrideFieldValue(
                'PrimaryTareWeight',
                overridenProposal.PackageInfo.ProposalPackageLevels[0]
                    .TareWeight
            );
        this.setOverridenDunnageType(
            this.proposalOverrideForm.controls['PrimaryDunnageType'].value,
            Constants.PRIMARY_LEVEL
        );
        overridenProposal.PackageInfo.ProposalPackageLevels[0].IsDunnageRequired =
            overridenProposal.PackageInfo.ProposalPackageLevels[0]
                .proposalPackageLevelDunnageTypes.length > 0
                ? true
                : false;
        overridenProposal.PackageInfo.ProposalPackageLevels[0].DunnageType =
            this.SetOverrideFieldValue(
                'PrimaryDunnage',
                overridenProposal.PackageInfo.ProposalPackageLevels[0]
                    .DunnageType
            );
        if (overridenProposal.PackageInfo.ProposalPackageLevels[1]) {
            overridenProposal.PackageInfo.ProposalPackageLevels[1].TareWeight =
                this.SetOverrideFieldValue(
                    'SecondaryTareWeight',
                    overridenProposal.PackageInfo.ProposalPackageLevels[1]
                        .TareWeight
                );
            this.setOverridenDunnageType(
                this.proposalOverrideForm.controls['SecondaryDunnageType']
                    .value,
                Constants.SECONDARY_LEVEL
            );
            overridenProposal.PackageInfo.ProposalPackageLevels[1].IsDunnageRequired =
                overridenProposal.PackageInfo.ProposalPackageLevels[1]
                    .proposalPackageLevelDunnageTypes.length > 0
                    ? true
                    : false;
            overridenProposal.PackageInfo.ProposalPackageLevels[1].DunnageType =
                this.SetOverrideFieldValue(
                    'SecondaryDunnage',
                    overridenProposal.PackageInfo.ProposalPackageLevels[1]
                        .DunnageType
                );
            overridenProposal.PackageInfo.ProposalPackageLevels[1].ContainersPerLayer =
                this.SetOverrideFieldValue(
                    'SecondaryContainersPerLayer',
                    overridenProposal.PackageInfo.ProposalPackageLevels[1]
                        .ContainersPerLayer
                );
            overridenProposal.PackageInfo.ProposalPackageLevels[1].NoOfLayers =
                this.SetOverrideFieldValue(
                    'SecondaryNoOfLayers',
                    overridenProposal.PackageInfo.ProposalPackageLevels[1]
                        .NoOfLayers
                );
        }
        if (overridenProposal.PackageInfo.ProposalPackageLevels[2]) {
            overridenProposal.PackageInfo.ProposalPackageLevels[2].TareWeight =
                this.SetOverrideFieldValue(
                    'TertiaryTareWeight',
                    overridenProposal.PackageInfo.ProposalPackageLevels[2]
                        .TareWeight
                );
            overridenProposal.PackageInfo.ProposalPackageLevels[2].ContainersPerLayer =
                this.SetOverrideFieldValue(
                    'TertiaryContainersPerLayer',
                    overridenProposal.PackageInfo.ProposalPackageLevels[2]
                        .ContainersPerLayer
                );
            overridenProposal.PackageInfo.ProposalPackageLevels[2].NoOfLayers =
                this.SetOverrideFieldValue(
                    'TertiaryNoOfLayers',
                    overridenProposal.PackageInfo.ProposalPackageLevels[2]
                        .NoOfLayers
                );
        }
    }

    setOverridenDunnageType(overridenProposalDunnage, level: number) {
        if (
            overridenProposalDunnage &&
            overridenProposalDunnage.length > 0 &&
            level == 2
        ) {
            this.createProposalDTO.OverriddenProposal.PackageInfo.ProposalPackageLevels[1].proposalPackageLevelDunnageTypes =
                [];
            overridenProposalDunnage.forEach((x) => {
                const ppldtVal = new ProposalPackageLevelDunnageType();
                ppldtVal.DunnageTypeId = x;
                ppldtVal.Enabled = true;
                this.createProposalDTO.OverriddenProposal.PackageInfo.ProposalPackageLevels[1].proposalPackageLevelDunnageTypes.push(
                    ppldtVal
                );
            });
        }
        if (
            overridenProposalDunnage &&
            overridenProposalDunnage.length > 0 &&
            level == 1
        ) {
            this.createProposalDTO.OverriddenProposal.PackageInfo.ProposalPackageLevels[0].proposalPackageLevelDunnageTypes =
                [];
            overridenProposalDunnage.forEach((x) => {
                const ppldtVal = new ProposalPackageLevelDunnageType();
                ppldtVal.DunnageTypeId = x;
                ppldtVal.Enabled = true;
                this.createProposalDTO.OverriddenProposal.PackageInfo.ProposalPackageLevels[0].proposalPackageLevelDunnageTypes.push(
                    ppldtVal
                );
            });
        }
    }

    SetOverrideFieldValue(fieldName: string, originalValue: any) {
        const controls = this.proposalOverrideForm.controls;
        if (
            controls[fieldName].value != null &&
            controls[fieldName].value != 0
        ) {
            return controls[fieldName].value;
        }
        return originalValue;
    }

    addFormControl(name: string, formGroup: FormGroup): void {
        this.proposalForm.addControl(name, formGroup);
        // set images
        // if (
        //     this.proposalForm.controls.hasOwnProperty(
        //         'proposalImagesMainForm'
        //     )
        // )
        // {

        // }
        // since tertiary is last definite form to get added (override is conditional), call refresh proposal DTO after tertiary is loaded.
        // if (
        //     this.proposalForm.controls.hasOwnProperty(
        //         'ProposalTertiaryPackageLevelForm'
        //     )
        // ) {
        //     if (this.proposalId) {
        //         const updateDTO = this.getProposal(this.proposalId);
        //     }
        // }
    }

    submitProposalClicked() {
        this.workflowStatusToSet = Constants.WORKFLOW_STATUS_SUBMITTED;
        this.submitProposal(true, this.proposalForm);
    }

    saveProposalClicked(docToBeUploaded?: DocumentToBeUploaded) {
        if (
            this.originalWorkFlowStatusId == Constants.WORKFLOW_STATUS_REJECTED
        ) {
            this.workflowStatusToSet = Constants.WORKFLOW_STATUS_REJECTED;
        } else {
            this.workflowStatusToSet = Constants.WORKFLOW_STATUS_NEW;
        }
        this.submitProposal(false, this.proposalForm, docToBeUploaded);
    }

    RefreshFormGroups() {
        if (this.proposalForm) {
            this.proposalBasicInfoForm = <FormGroup>(
                this.proposalForm.controls['proposalBasicInfoForm']
            );
            this.partInfoInProposalForm = <FormGroup>(
                this.proposalBasicInfoForm.controls['partInfoInProposalForm']
            );
            this.packageInfoForm = <FormGroup>(
                this.proposalBasicInfoForm.controls['packageInfoForm']
            );
            this.manufacturingLocationForm = <FormGroup>(
              this.proposalBasicInfoForm.controls['manufacturingLocationForm']
            );
            this.secondaryProcessingLocationForm = <FormGroup>(
              this.proposalBasicInfoForm.controls['secondaryProcessingLocationForm']
            );
            this.proposalPrimaryPackageLevelForm = <FormGroup>(
                this.proposalForm.controls['ProposalPrimaryPackageLevelForm']
            );
            this.proposalSecondaryPackageLevelForm = <FormGroup>(
                this.proposalForm.controls['ProposalSecondaryPackageLevelForm']
            );
            this.proposalTertiaryPackageLevelForm = <FormGroup>(
                this.proposalForm.controls['ProposalTertiaryPackageLevelForm']
            );
            this.proposalOverrideForm = <FormGroup>(
                this.proposalForm.controls['proposalOverrideForm']
            );
            this.proposalImagesForm = <FormGroup>(
                this.proposalForm.controls['ProposalImagesForm']
            );
            this.externalComments = <FormGroup>(
                this.proposalForm.controls['externalComments']
            );
            this.physicalinspection = <FormGroup>(
                this.proposalForm.controls['physicalinspection']
            );
            this.proposalLogisticsInfoForm = <FormGroup>(
                this.proposalForm.controls['proposalLogisticsInfoForm']
            );
        }
    }

    OnEffectiveDatesChanged($event) {
        this.effectiveDatesChanged = true;
    }

   

    submitProposal(
        IsForSubmit: boolean = true,
        proposalForm: FormGroup,
        docToBeUploaded?: DocumentToBeUploaded,
        forceUpdate: boolean = false
    ) {
        // mark all fields as touched
        this.FormService.markFormGroupTouched(this.proposalForm);
        if (!this.ValidateForm(IsForSubmit)) {
            return;
        }
        var OkToProceed = this.ValidateMaxStackHeight();
        if (!OkToProceed) {
            return;
        }
        // let lengthSum = 0;
        // this.createProposalDTO.DefaultProposal.ImageInfo.forEach(x => {
        //     lengthSum += x.Url.length;
        // });
        // if (lengthSum >= 548915 ) {
        //     this.toastService.error(
        //         'Proposal images too large, please make sure they are under 1.5mb total.'
        //     );
        //     return;
        // }
        //  this.RefreshFormGroups();

        //We now need to check if this change would create any gaps
        

        
        // right before we submit our form to the server we check if the form is valid
        // if not, we pass the form to the validateform function again. Now with check dirty false
        // this means we check every form field independent of wether it's touched
        if (this.proposalForm.valid) {
            // console.log(this.createProposalDTO);
            // return;

            if(this.effectiveDatesChanged && !this.canProceedWithUpdate && this.pacakeTypeId == Constants.ReturnablePackagingTypeId) {
                this.dataService.checkForEffectivyGaps(this.createProposalDTO)
                    .subscribe(data =>{
                        if(data && data.Data && data.Data.FieldChanged) {
                            //this means there would be  a gap
                            //display MatDialog with 3 choices
                            //capture the response and proceed with the update
                            const dialogRef = this.matDialog.open(ProposalGapConfirmComponent, {
                                        height: '270px',
                                        width: '700px',
                                        data: data.Data,
                                    });
                            dialogRef.afterClosed().subscribe((result) => {
                                switch(result) {
                                    case "Abort":
                                        return; 
                                    case "Leave":
                                        this.canProceedWithUpdate = true;
                                        this.createProposalDTO.GapOverrideResponse = Constants.LEAVE_GAP;
                                        break;
                                    case "Bridge": 
                                        this.canProceedWithUpdate = true;
                                        this.createProposalDTO.GapOverrideResponse = Constants.BRIDGE_GAP;
                                        break;
                                }
                                this.submitProposal(IsForSubmit, proposalForm, docToBeUploaded, forceUpdate);
                            });
                        } else {
                            this.canProceedWithUpdate = true;
                            this.submitProposal(IsForSubmit, proposalForm, docToBeUploaded, forceUpdate);
                        }
                    });
                return;
            } 

            this.proposalbasicinfoComponent.setValuesForConversionOrSaving();
            this.packagelevelComponents.forEach((x) =>
                x.setValuesForConversionOrSaving()
            );
            this.updateDefaultProposal(true);
            if (forceUpdate) {
                this.createProposalDTO.DefaultProposal.AckUpdate = true;
            }
            this.logDebug(
                'this.createProposalDTO to be create/update',
                this.createProposalDTO
            );
            this.SubmitClicked = true;
            this.scrollToTop();
            if (this.isUpdateMode) {
                this.dataService
                    .updateProposal(this.createProposalDTO)
                    .subscribe((data) => {
                        // this.partInfo = data
                        if (data != null) {
                            var d = data as any;
                            if (d.Messages && d.Messages['length']) {
                                if (confirm(d.Messages[0] + ", Do you want to force the submission?")) {
                                    this.submitProposal(IsForSubmit, proposalForm, docToBeUploaded, true);
                                }
                                return;
                            }

                            if (IsForSubmit) {
                                this.toastService.success(
                                    'Proposal ' +
                                        Constants.SUCCESS_SUBMITTED_GENERIC
                                );
                            } else {
                                this.toastService.success(
                                    'Proposal ' + Constants.SUCCESS_SAVE_GENERIC
                                );
                            }
                            this.navigateToNextPage();
                        }
                    });
            } else {
                this.dataService
                    .createProposal(this.createProposalDTO)
                    .subscribe((response) => {
                        // this.partInfo = data
                        if (response != null) {
                            this.isUpdateMode = true;
                            this.proposalId = response.Data;
                            this.proposalService.RefreshsavedproposalIds(
                                response.Data
                            );
                            this.createProposalDTO.DefaultProposal.ProposalId =
                                response.Data;
                            if (docToBeUploaded) {
                                this.uploadDocument(docToBeUploaded);
                                this.toastService.success(
                                    'File uploaded after saving the proposal draft',
                                    true
                                );
                            } else {
                                if (IsForSubmit) {
                                    this.toastService.success(
                                        'Proposal ' +
                                            Constants.SUCCESS_SUBMITTED_GENERIC
                                    );
                                } else {
                                    this.toastService.success(
                                        'Proposal ' +
                                            Constants.SUCCESS_SAVE_GENERIC
                                    );
                                }
                            }
                            if (
                                this.createProposalDTO.DefaultProposal
                                    .PackageInfo.WorkflowStatusId !=
                                Constants.WORKFLOW_STATUS_SUBMITTED
                            ) {
                                this.navigateToSavedProposals();
                            } else {
                                this.navigateToNextPage();
                            }
                            // this.NewProposalInDraftModeCreated = true;
                            // this.router.navigate(['../', 'proposal'], {queryParams: { id: response.Data}});
                        }
                    });
            }

            //  this.proposalForm.reset();
        } else {
         
            // this.FormService.ValidateFormHierarchy(this.proposalForm.controls['proposalBasicInfoForm'].value, this.formErrors, false)
            // set invalid indicators in tab headings
            this.SubmitClicked = false;
            this.scrollToTop();
            this.setInvalidIndicators();
            this.toastService.error(Constants.ERROR_PROPOSAL_CHECK_VALIDATIONS);
        }
    }

    navigateToSavedProposals() {
        this.router.navigate(['/saved-proposals']);
    }

    navigateToNextPage() {
        if (this.IsSupplier) {
            if (
                this.createProposalDTO.DefaultProposal.PackageInfo
                    .WorkflowStatusId == Constants.WORKFLOW_STATUS_REJECTED
            ) {
                this.router.navigate(['/Rejectedproposals']);
            } else if (
                this.createProposalDTO.DefaultProposal.PackageInfo
                    .WorkflowStatusId == Constants.WORKFLOW_STATUS_SUBMITTED
            ) {
                // TMS-17427 Add Submitted proposal view UI for suppliers
                this.router.navigate(['/Submittedproposals']);
            } else {
                this.router.navigate(['/Pendingproposals']);
            }
        } else {
            this.router.navigate(['/pe-createproposal']);
        }
    }

    navigateToUpdateProposal(id: number) {
        this.router.navigate(['/proposal', id]);
        // window.sourceType.href = '/proposal/' + id;
    }

    setInvalidIndicators() {
        this.RefreshFormGroups();

        this.proposalBasicInfoForm_Invalid = Helper.ShowInvalidFormIndicator(
            this.proposalBasicInfoForm
        );
        this.partInfoInProposalForm_Invalid = Helper.ShowInvalidFormIndicator(
            this.partInfoInProposalForm
        );
        this.packageInfoForm_Invalid = Helper.ShowInvalidFormIndicator(
            this.packageInfoForm
        );
        this.proposalManufacturingLocationForm_Invalid = Helper.ShowInvalidFormIndicator(
            this.manufacturingLocationForm
        );
        this.proposalSecondaryProcessingLocationForm_Invalid = Helper.ShowInvalidFormIndicator(
            this.secondaryProcessingLocationForm
        );
        this.proposalPrimaryPackageLevelForm_Invalid =
            Helper.ShowInvalidFormIndicator(
                this.proposalPrimaryPackageLevelForm
            );
        this.proposalSecondaryPackageLevelForm_Invalid =
            Helper.ShowInvalidFormIndicator(
                this.proposalSecondaryPackageLevelForm
            );
        this.proposalTertiaryPackageLevelForm_Invalid =
            Helper.ShowInvalidFormIndicator(
                this.proposalTertiaryPackageLevelForm
            );
        this.proposalImagesForm_Invalid = Helper.ShowInvalidFormIndicator(
            this.proposalImagesForm
        );
        this.proposalLogisticsInfoForm_Invalid =
            Helper.ShowInvalidFormIndicator(this.proposalLogisticsInfoForm);
        if (this.proposalOverrideForm) {
            this.proposalOverrideForm_Invalid = Helper.ShowInvalidFormIndicator(
                this.proposalOverrideForm
            );
        }

        this.proposalBasicInfoForm_Valid = Helper.ShowValidFormIndicator(
            this.proposalBasicInfoForm
        );
        this.partInfoInProposalForm_Valid = Helper.ShowValidFormIndicator(
            this.partInfoInProposalForm
        );
        this.packageInfoForm_Valid = Helper.ShowValidFormIndicator(
            this.packageInfoForm
        );
        this.proposalManufacturingLocationForm_Valid = Helper.ShowValidFormIndicator(
          this.manufacturingLocationForm
        );
        this.proposalSecondaryProcessingLocationForm_Valid = Helper.ShowValidFormIndicator(
          this.secondaryProcessingLocationForm
        );
        this.proposalPrimaryPackageLevelForm_Valid =
            Helper.ShowValidFormIndicator(this.proposalPrimaryPackageLevelForm);
        this.proposalSecondaryPackageLevelForm_Valid =
            Helper.ShowValidFormIndicator(
                this.proposalSecondaryPackageLevelForm
            );
        this.proposalTertiaryPackageLevelForm_Valid =
            Helper.ShowValidFormIndicator(
                this.proposalTertiaryPackageLevelForm
            );
        this.proposalImagesForm_Valid = Helper.ShowValidFormIndicator(
            this.proposalImagesForm
        );
        this.proposalLogisticsInfoForm_Valid = Helper.ShowValidFormIndicator(
            this.proposalLogisticsInfoForm
        );
        if (this.proposalOverrideForm) {
            this.proposalOverrideForm_Valid = Helper.ShowValidFormIndicator(
                this.proposalOverrideForm
            );
        }
    }

    // GetFormValidIndicator(formGroupName: string) : boolean
    // {
    //    // return Helper.ShowInvalidFormIndicator(<FormGroup>this.proposalForm.controls[formGroupName]);
    //    return ((g.dirty || g.touched) && g.invalid);
    // }

    selectedTabChange(event: MatTabChangeEvent) {
        if (this.selectedTabIndex !== event.index) {
            this.validateTabChange(this.selectedTabIndex);
        } else {
            this.validateTabChange(this.selectedTabIndex - 1);
        }
        this.selectedTabIndex = event.index;
        this.proposalService.RefreshProposalTabsSelectedIndex(event.index);
    }

    deleteImage(imageToBeDeleted: ImageToBeDeleted) {
        if (
            imageToBeDeleted.Id != null &&
            imageToBeDeleted.Id != undefined &&
            imageToBeDeleted.Id != 0
        ) {
            this.dataService
                .deleteImage(imageToBeDeleted.Id)
                .subscribe((response) => {
                    if (response != null) {
                        const index =
                            this.createProposalDTO.DefaultProposal.ImageInfo.findIndex(
                                (x) => x.Id == imageToBeDeleted.Id
                            );
                        if (index > -1) {
                            this.createProposalDTO.DefaultProposal.ImageInfo.splice(
                                index,
                                1
                            );
                        }
                        this.logDebug(this.createProposalDTO);
                        this.proposalimagesComponent.setControlValues(
                            this.createProposalDTO
                        );
                        this.physicalinspectionComponent.setControlValues(
                            this.createProposalDTO
                        );
                    }
                });
        } else {
            const index =
                this.createProposalDTO.DefaultProposal.ImageInfo.findIndex(
                    (x) =>
                        x.UUId == imageToBeDeleted.Url &&
                        x.Id == imageToBeDeleted.Id
                );
            if (index > -1) {
                this.createProposalDTO.DefaultProposal.ImageInfo.splice(
                    index,
                    1
                );
            }
            this.proposalimagesComponent.setControlValues(
                this.createProposalDTO
            );
            this.physicalinspectionComponent.setControlValues(
                this.createProposalDTO
            );
        }
    }

    deleteOverrideImage(imageToBeDeleted: ImageToBeDeleted) {
        if (
            imageToBeDeleted.Id != null &&
            imageToBeDeleted.Id != undefined &&
            imageToBeDeleted.Id != 0
        ) {
            this.dataService
                .deleteImage(imageToBeDeleted.Id)
                .subscribe((response) => {
                    if (response != null) {
                        const index = this.overridenImages.findIndex(
                            (x) => x.Id == imageToBeDeleted.Id
                        );
                        if (index > -1) {
                            this.overridenImages.splice(index, 1);
                        }
                        this.createProposalDTO.OverriddenProposal.ImageInfo =
                            this.overridenImages;
                        this.logDebug(this.createProposalDTO);
                        this.proposaloverrideComponent.setControlValues(
                            this.createProposalDTO
                        );
                    }
                });
        } else {
            const index = this.overridenImages.findIndex(
                (x) =>
                    x.UUId == imageToBeDeleted.Url &&
                    x.Id == imageToBeDeleted.Id
            );
            if (index > -1) {
                this.overridenImages.splice(index, 1);
            }
            this.createProposalDTO.OverriddenProposal.ImageInfo =
                this.overridenImages;
            // debug if deleted from CreateDTO
            this.logDebug(this.createProposalDTO);
            this.proposaloverrideComponent.setControlValues(
                this.createProposalDTO
            );
        }
    }

    newOverrideImageUploaded(imageToBeUploaded: FileToBeUploaded) {
        const uploadedImage: ProposalImage = {
            Id: 0,
            LegacyId: null,
            Type: imageToBeUploaded.Type,
            UUId: imageToBeUploaded.File,
            ProposalId: +this.proposalId,
            Category: imageToBeUploaded.Category,
            FileName: imageToBeUploaded.FileName,
            Enabled: true,
            IsSelected: true,
            DisplayUrl: '',
        };
        this.overridenImages.push(uploadedImage);
        this.createProposalDTO.OverriddenProposal.ImageInfo =
            this.overridenImages;
        this.logDebug(
            'new image pushed to overide prop',
            this.createProposalDTO.OverriddenProposal.ImageInfo
        );
        this.proposaloverrideComponent.setControlValues(this.createProposalDTO);
    }

    deleteDocument(docToBeDeleted: DocumentToBeDeleted) {
        if (
            docToBeDeleted.Id != null &&
            docToBeDeleted.Id != undefined &&
            docToBeDeleted.Id != 0
        ) {
            this.dataService
                .deleteDocument(docToBeDeleted.Id)
                .subscribe((response) => {
                    if (response != null) {
                        const index =
                            this.createProposalDTO.DefaultProposal.DocumentInfo.findIndex(
                                (x) => x.Id == docToBeDeleted.Id
                            );
                        if (index > -1) {
                            this.createProposalDTO.DefaultProposal.DocumentInfo.splice(
                                index,
                                1
                            );
                        }
                        this.logDebug(this.createProposalDTO);
                        this.proposalimagesComponent.setControlValues(
                            this.createProposalDTO
                        );
                    }
                });
        } else {
            const index =
                this.createProposalDTO.DefaultProposal.DocumentInfo.findIndex(
                    (x) =>
                        x.UUId == docToBeDeleted.Url &&
                        x.Id == docToBeDeleted.Id
                );
            if (index > -1) {
                this.createProposalDTO.DefaultProposal.DocumentInfo.splice(
                    index,
                    1
                );
            }
            this.proposalimagesComponent.setControlValues(
                this.createProposalDTO
            );
        }
    }
    uploadDocument(docToBeUploaded: DocumentToBeUploaded) {
        // debugger;
        this.dataService
            .uploadDocument(
                docToBeUploaded.File,
                String(this.proposalId),
                String(docToBeUploaded.Type)
            )
            .subscribe((response) => {
                if (response != null) {
                    const uploadedDoc: ProposalDocument = {
                        LegacyId: null,
                        Id: response.Data.Id,
                        Type: response.Data.Type,
                        UUId: response.Data.Url,
                        ProposalId: +this.proposalId,
                        FileName: response.Data.FileName,
                        Enabled: true,
                        IsSelected: true,
                    };
                    // this.imageUploaded.emit(uploadedImage);
                    this.createProposalDTO.DefaultProposal.DocumentInfo.push(
                        uploadedDoc
                    );
                    this.logDebug(this.createProposalDTO);
                    this.proposalimagesComponent.setControlValues(
                        this.createProposalDTO
                    );
                }
            });
    }

    uploadInspectionImage(imageToBeUploaded: FileToBeUploaded) {
        const uploadedImage: ProposalImage = {
            Id: 0,
            LegacyId: null,
            Type: imageToBeUploaded.Type,
            UUId: imageToBeUploaded.File,
            ProposalId: +this.proposalId,
            Category: imageToBeUploaded.Category,
            FileName: imageToBeUploaded.FileName,
            Enabled: true,
            IsSelected: true,
            DisplayUrl: '',
        };
        this.createProposalDTO.DefaultProposal.ImageInfo.push(uploadedImage);
        this.physicalinspectionComponent.setControlValues(
            this.createProposalDTO
        );
        this.dataService
            .uploadInspectionImage(uploadedImage)
            .subscribe((response: any) => {
                if (response != null && response.Data != null) {
                    const uploadedImage: ProposalImage = {
                        Id: response.Data.Id,
                        LegacyId: null,
                        Type: response.Data.Type,
                        UUId: response.Data.Url,
                        Category: imageToBeUploaded.Category,
                        ProposalId: +this.proposalId,
                        FileName: response.Data.FileName,
                        Enabled: true,
                        IsSelected: true,
                        DisplayUrl: '',
                    };
                    // this.imageUploaded.emit(uploadedImage);
                }
            });
    }

    newImageUploaded(imageToBeUploaded: FileToBeUploaded) {
        // debugger;
        // if only creating new and no
        const uploadedImage: ProposalImage = {
            Id: 0,
            LegacyId: null,
            Type: imageToBeUploaded.Type,
            UUId: imageToBeUploaded.File,
            ProposalId: +this.proposalId,
            Category: imageToBeUploaded.Category,
            FileName: imageToBeUploaded.FileName,
            Enabled: true,
            IsSelected: true,
            DisplayUrl: '',
        };
        this.createProposalDTO.DefaultProposal.ImageInfo.push(uploadedImage);
        /**
         * TMS-16613 Show specific error message for Image size issue in portal
         */
        // Validate uploaded images size
        if (
            !Helper.CheckProposalImagesSize(
                this.createProposalDTO.DefaultProposal.ImageInfo
            )
        ) {
            this.createProposalDTO.DefaultProposal.ImageInfo.pop();
            this.toastService.error(
                `You can upload up to ${
                    Constants.FILE_UPLOAD_MAX_SIZE / 1e6
                } MB attachments in total.`
            );
            return;
        }
        this.logDebug(
            'new image pushed to default prop',
            this.createProposalDTO.DefaultProposal.ImageInfo
        );
        this.proposalimagesComponent.setControlValues(this.createProposalDTO);

        // if (
        //     (!this.createProposalDTO.DefaultProposal.ImageInfo ||
        //     this.createProposalDTO.DefaultProposal.ImageInfo.length == 0) && (!this.isUpdateMode)
        // ) {
        //     // if first image, save the draft first
        //     this.saveProposalClicked(imageToBeUploaded);
        // }
        // else
        // {
        //     this.uploadImage(imageToBeUploaded);
        // }
    }

    newDocumentUploaded(docToBeUploaded: DocumentToBeUploaded) {
        // for documents, it must have proposal id reference, so save a draft before upload and use the id
        if (!this.proposalId) {
            this.saveProposalClicked(docToBeUploaded);
        } else {
            this.uploadDocument(docToBeUploaded);
        }
    }

    gotoPendingProposals() {
        this.router.navigate(['/', 'Pendingproposals']);
    }

    goToUpdatePage() {
        window.location.href = '/proposal/' + this.proposalId;
    }

    TemplateSelected(level, event) {
        this.selectedTemplates[level -1] = event;
    }

    TemplateCleared(level, event) {
        this.selectedTemplates[level -1] = null;
    }

    ValidateForm(IsForSubmit: boolean) : boolean{
        // all validations only if for submit, Only 'required'/mandatory field validation for draft save
        this.proposalbasicinfoComponent.ValidateForm(IsForSubmit);
        if (this.proposaloverrideComponent) {
            this.proposaloverrideComponent.ValidateForm(IsForSubmit);
        }

        if (this.pacakeTypeId == 1) {
            var templates = this.selectedTemplates.filter(option => option!= null && option.EffectiveFrom);
            var dateArray = templates.map(option => new Date(option.EffectiveFrom).getTime());
            var maxFrom  =  new Date( Math.max(...dateArray));
            dateArray = templates.map(option => new Date(option.EffectiveTo).getTime());
            var minTo = new Date(Math.min(...dateArray));
            var propEffFrom = new Date(this.packageInfoForm.controls['EffectiveFrom'].value);
            var propEffTo = new Date(this.packageInfoForm.controls['EffectiveTo'].value);

            if (propEffFrom >= propEffTo) {
                var message = `Dear user, proposal end date cant be before start date`;
                this.toastService.error(message); 
                return false;
            }

            if(propEffFrom < maxFrom) {
                var template = this.selectedTemplates.find(item => item && new Date(item.EffectiveFrom).getTime() == maxFrom.getTime());
                var level = this.selectedTemplates.indexOf(template) + 1;
                var layer = "Tertiary";
                switch (level) {
                    case 1: layer = "Primary";
                    break;
                    case 2: layer = "Secondary";
                    break;
                }
                
                var message = `Dear user, you used package code <${template.TeslaEquipmentCode}> in the <${layer}> layer that has an effective start date of ${Helper.formatDate(maxFrom)}, so the effective start date of the proposal cannot be before ${Helper.formatDate(maxFrom)}. Please update the effective start date to on or after ${Helper.formatDate(maxFrom)}. If you think that is not accurate, please contact your respective packaging engineer to update the effectivity dates of the template.`
                this.toastService.error(message); 
                return false;
            }

            if(propEffTo > minTo) {
                var template = this.selectedTemplates.find(item => item && new Date(item.EffectiveTo).getTime() == minTo.getTime());
                var level = this.selectedTemplates.indexOf(template) + 1;
                var layer = "Tertiary";
                switch (level) {
                    case 1: layer = "Primary";
                    break;
                    case 2: layer = "Secondary";
                    break;
                }
                
                var message = `Dear user, you used package code <${template.TeslaEquipmentCode}> in the <${layer}> layer that has an effective end date of ${Helper.formatDate(minTo)}, so the effective end date of the proposal cannot be after ${Helper.formatDate(minTo)}. Please update the effective end date to on or before ${Helper.formatDate(minTo)}. If you think that is not accurate, please contact your respective packaging engineer to update the effectivity dates of the template.`
                this.toastService.error(message); 
                return false;
            }
        }

        if(IsForSubmit) {

            //we get  the controls of the form
            var controls = this.packagelevelComponents.first.ProposalPackageLevelForm.controls;
            //we list all the controls that are not PackageLevelId nor ContainersPerLayer
            var controlKeys =  ['PackageMaterialOption'];
            
            //if any form has any value set for any control  excluding the two above means the user has set a value
            //we therefore calculate how many levels there should be
            const noLevels = this.packagelevelComponents.filter(x => controlKeys.filter(key => { 

                var controlValue = x.ProposalPackageLevelForm.controls[key].value;
                if (!!!controlValue) {
                    return false;
                }
                return true;
            }).length > 0).length;
            var lastLayerDTO = this.createProposalDTO.DefaultProposal.PackageInfo.ProposalPackageLevels[noLevels -1];
            var lastLayerForm = this.packagelevelComponents.filter(item => item.level == lastLayerDTO.PackageLevelId);
            var isShowShippableCheck = lastLayerForm[0].ShowInnerPackCheckBox;

            if (lastLayerDTO.IsShippable != true && isShowShippableCheck) {
                this.toastService.error("Dear User, you are about to submit a proposal where all the layers are marked as Not Shippable. For a proposal to be valid, at least one of the proposal layers has to be Shippable. Please review and correct.");
                lastLayerForm[0].ProposalPackageLevelForm.controls["IsShippable"].setErrors(
                    { lastLayerIsNotShippable: true }
                );
            
            } else {
                lastLayerForm[0].ProposalPackageLevelForm.controls["IsShippable"].setErrors(
                    null
                );
            }
        }

        this.packagelevelComponents.forEach((packagelevelComponent) => {
            packagelevelComponent.ValidateForm(IsForSubmit);
        });
        this.proposalLogisticsComponent.ValidateForm(IsForSubmit);
        this.setOkToImageUploadFlag();
        // don't allow to submit if no images
        this.proposalimagesComponent.ValidateForm(IsForSubmit);
        return true;
    }

    ValidateMaxStackHeight() {
        var highestLevelStackHeight = 0;
        const primaryLevel = cloneDeep(
            this.proposalPrimaryPackageLevelForm.value
        );
        const secondaryLevel = cloneDeep(
            this.proposalSecondaryPackageLevelForm.value
        );
        const tertiaryLevel = cloneDeep(
            this.proposalTertiaryPackageLevelForm.value
        );
        // for highest applicable level calculate current stack height ( using stackable units for shipping also)
        var stackableUnitsForShipping =
            this.proposalLogisticsInfoForm.controls[
                'NoOfStackableUnitsForShipping'
            ].value;
        if (tertiaryLevel.PackageMaterialId) {
            var secondaryLevelStackHeight =
                primaryLevel.Height * secondaryLevel.NoOfLayers;
            highestLevelStackHeight =
                secondaryLevelStackHeight *
                tertiaryLevel.NoOfLayers *
                stackableUnitsForShipping;
        } else {
            if (secondaryLevel.PackageMaterialId) {
                highestLevelStackHeight =
                    primaryLevel.Height *
                    secondaryLevel.NoOfLayers *
                    stackableUnitsForShipping;
            } else {
                highestLevelStackHeight = primaryLevel.Height;
            }
        }
        // if max allowed stack height is available, validate using that else validate against stackable units for shipping only.
        var maxAllowedStackHeight = this.getMaxStackHeight();
        var confirmPrompt = '';
        if (maxAllowedStackHeight > 0) {
            if (highestLevelStackHeight > maxAllowedStackHeight) {
                confirmPrompt =
                    'Current stack height (' +
                    highestLevelStackHeight +
                    ') exceeds maximum allowed stack height (' +
                    maxAllowedStackHeight +
                    '). Do you still want to proceed?';
                console.log(confirmPrompt);
            }
        } else {
            if (
                stackableUnitsForShipping >
                Constants.MAX_ALLOWED_STACKABLE_UNITS_SHIPPING
            ) {
                confirmPrompt =
                    'Maximum allowed stackable units for shipping is ' +
                    Constants.MAX_ALLOWED_STACKABLE_UNITS_SHIPPING +
                    '. Do you still want to proceed?';
            }
        }
        console.log('confirmPrompt=' + confirmPrompt);
        if (confirmPrompt != '') {
            return window.confirm(confirmPrompt);
        } else {
            return true;
        }
    }
    getMaxStackHeight() {
        try {
            const sourceTypeId =
                this.createProposalDTO.DefaultProposal.PackageInfo.SourceTypeId;
            const arrDefinedMaxStackHeights = Constants.MAXSTACK[sourceTypeId];
            if (arrDefinedMaxStackHeights) {
                // will  be undefined in case nothing is defined for current sourcetypeid
                const definedMaxStackHeightObj = arrDefinedMaxStackHeights.find(
                    (o) => o.transportmodeid == this.transportModeId
                );

                return definedMaxStackHeightObj
                    ? Helper.calculateDim(definedMaxStackHeightObj.maxstackheight, this.globalUOM, false)
                    : 0;

            } else {
                return 0;
            }
        } catch (error) {
            console.log('Error in getMaxStackHeight' + error);
            return 0;
        }
    }
    setOkToImageUploadFlag() {
        if (!this.isUpdateMode) {
            this.OkTOUploadImages = this.AllExceptImageFormValid();
        }
    }
    AllExceptImageFormValid() {
        let okToupload =
            this.proposalBasicInfoForm.valid &&
            this.proposalPrimaryPackageLevelForm.valid &&
            this.proposalSecondaryPackageLevelForm.valid &&
            this.proposalLogisticsInfoForm.valid;
        if (this.proposalOverrideForm) {
            okToupload = okToupload && this.proposalOverrideForm.valid;
        }
        return okToupload;
    }

    validateTabChange(index: number) {
        if (index === 0) {
            this.proposalbasicinfoComponent.ValidateForm(false);
        } else if (index > 0 && index < 4) {
            this.packagelevelComponents
                .find((x) => x.level === index)
                .ValidateForm(false);
            // Revert TMS-5240
            //    this.formError.Height = '';
            //    this.formError.Length = '';
            //    this.formError.Width = '';
            //    if (index === Constants.PRIMARY_LEVEL && this.proposalPrimaryPackageLevelForm.dirty) {
            //         this.formError = PartPackageLevelValidator(this.partInfoInProposalForm, this.proposalPrimaryPackageLevelForm, this.formError);
            //    } else if (index === Constants.SECONDARY_LEVEL && this.proposalSecondaryPackageLevelForm.dirty) {
            //         this.formError = PartPackageLevelValidator(this.proposalPrimaryPackageLevelForm, this.proposalSecondaryPackageLevelForm, this.formError);
            //    } else if (index === Constants.TERTIARY_LEVEL && this.proposalSecondaryPackageLevelForm.dirty && this.proposalTertiaryPackageLevelForm.dirty) {
            //         this.formError = PartPackageLevelValidator (this.proposalSecondaryPackageLevelForm, this.proposalTertiaryPackageLevelForm, this.formError);
            //    }
            //    this.validateLevels(index);
        }
        this.setInvalidIndicators();
    }

    validateLevels(index: number = 0) {
        if (
            this.formError['Height'] !== '' ||
            this.formError['Length'] !== '' ||
            this.formError['Width'] !== ''
        ) {
            this.toastService.error(
                'Part dimensions should be less than package dimensions. Also, dimensions of each package level needs to be less than the next level.'
            );
            this.packagelevelComponents
                .find((x) => x.level === index)
                .ProposalPackageLevelForm.setErrors({
                    valueLessThanPreviousLayer: true,
                });
        } else {
            this.packagelevelComponents
                .find((x) => x.level === index)
                .ProposalPackageLevelForm.setErrors(null);
        }
    }
}
